import React from "react";
import { fmtPct } from "@/lib/api";

export function Progress({ value = 0, label = true }) {
  const pct = Math.min(1, Math.max(0, value));
  return (
    <div className="flex items-center gap-2 w-full">
      <div className="ox-progress flex-1">
        <span style={{ width: `${pct * 100}%` }} />
      </div>
      {label && (
        <span className="mono text-[10px] text-muted-foreground tabular-nums w-9 text-right">
          {fmtPct(pct)}
        </span>
      )}
    </div>
  );
}
